<div class="app-list-results" *ngIf="!(loaderService.loading | async)">
  <div class="flex-row flex-space-between align-items-flexed" *ngIf="showResultsLabel">
    <div class="flex-row--sort">
      <div class="sort-dropdown">
        <label for="sortBy">{{ 'GenericSortBy' | smartlabel: { fallback: 'Sort by' } | async }}</label>
        <select id="sortBy" data-testid="7CF7FA26-A147-4121-9834-D2E8D6D8923F" class="form-control" [formControl]="eventSearchForm.controls.sortFieldAndDirection" (change)="eventSearchForm.search()">
          <option *ngFor="let sortField of eventSearchForm.sortOptions" [value]="sortField.value">{{ sortField.name | smartlabel: { fallback: sortField.name } | async }}</option>
        </select>
      </div>
    </div>
    <div class="flex-row--count">
      <div class="pagination-box">
        <pageresult-counter [pageNumber]="eventSearchForm.currentPage"
                            [pageSize]='eventSearchForm.pageSize'
                            [totalCount]="eventSearchForm.totalCount"></pageresult-counter>
      </div>
    </div>
  </div>

  <app-event-search-list-record class="list" *ngFor="let event of eventSearchForm.resultModels" [event]="event" (exitEventList)="exitEventList($event)"></app-event-search-list-record>
  
  <div>
    <div class="registry-warning app-width" *ngIf="showNoAvailableResultsLabel">
      <p class="alert-title">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        {{ 'TrainingProviderEventSearchNoEventsTitle' | smartlabel: { fallback: 'No Events Available' } | async }}
      </p>
      <p>{{ 'TrainingProviderEventSearchNoEventsMessage' | smartlabel: { fallback: 'There are no events ending today or in the recent past. Try searching to view older or upcoming events.' } | async }}</p>
    </div>
    <div class="registry-warning app-width" *ngIf="showNoResultsFoundLabel">
      <p class="alert-title">
        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        {{ 'TrainingProviderEventSearchNoResultsTitle' | smartlabel: { fallback: 'No Events Found' } | async }}
      </p>
      <p>{{ 'TrainingProviderEventSearchNoResultsMessage' | smartlabel: { fallback: 'Please adjust your search criteria and search again.' } | async }}</p>
    </div>
  </div>

  <div class="pagination-box">
    <ngx-pager (pageChanged)="eventSearchForm.onPageChanged($event)"
               [pageNumber]="eventSearchForm.currentPage"
               [pageSize]='eventSearchForm.pageSize'
               [showPageCounter]='showResultsLabel'
               [totalCount]="eventSearchForm.totalCount"></ngx-pager>
  </div>  
</div>

 
